<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="content-center">
        <div class="footer-left">
          <img src="@/assets/images/footer-logo.png" alt="Logo" class="footer-logo">
          <p>友情链接：<a href="https://ascend-global.com/#/home?lang=cn" target="_blank">爱圣国际教育集团有限公司</a></p>
          <p>All Rights Reserved. 深圳市爱圣公益基金会 版权所有</p>
          <p>备案号：粤ICP备2022055650号-1<img src="@/assets/images/police-icon.jpg" alt="">粤公网安备 44030502008984号</p>
        </div>
        <div class="footer-right">
          <ul class="footer-nav">
            <li>
              <router-link to="/">
                首页
              </router-link>
            </li>
            <li>
              <router-link to="/about">
                关于我们
              </router-link>
            </li>
            <li>
              <router-link to="/projects">
                公益项目
              </router-link>
            </li>
            <li>
              <router-link to="/arete">
                爱德说
              </router-link>
            </li>
            <li>
              <router-link to="/info">
                信息公开
              </router-link>
            </li>
            <li>
              <router-link to="/news">
                资讯
              </router-link>
            </li>
          </ul>
          <div class="footer-contact">
            <div class="contact-left">
              <p>电话：0755-86638810</p>
              <p>邮箱：info@ascendfoundation.org.cn</p>
              <p>地址：深圳市南山区粤海街道科苑南路2666号中国华润大厦</p>
            </div>
            <div class="contact-right">
              <img src="@/assets/images/code.jpg" alt="QR Code" class="footer-qrcode">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-bottom" />
  </footer>
</template>

<script>
export default {
  name: 'AppFooter'
}
</script>

<style scoped lang="scss">
.footer {
  width: 100%;
  background-color: #eff7f2;
  padding-top: 56px;
  text-align: center;

  .footer-container {
    width: 100%;
  }

  .content-center {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  .footer-left {
    text-align: left;
    a {
      color: #000;
      text-decoration: underline;
      text-underline-offset: 3px;
    }

    .footer-logo {
      display: inline-block;
      width: 178px;
      height: 58px;
      margin-bottom: 36px;
    }

    p {
      margin-bottom: 16px;
    }

    img {
      width: 16px;
      height: 16px;
      margin-left: 4px;
      margin-right: 4px;
      vertical-align: bottom;
    }
  }

  .footer-right {
    text-align: right;

    .footer-nav {
      display: flex;
      margin-bottom: 40px;

      li {
        margin-right: 32px;

        &:last-child {
          margin-right: 0;
        }

        a {
          display: inline-block;
          width: 86px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          text-decoration: none;
          color: #000;
        }
      }
    }

    .footer-contact {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-left: 30px;

      .contact-left {
        text-align: left;
        margin-top: 16px;

        p {
          margin-bottom: 16px;
        }
      }

      .contact-right {
        .footer-qrcode {
          width: 80px;
          height: 80px;
        }
      }
    }
  }

  .footer-bottom {
    height: 24px;
    width: 100%;
    background-color: #1e7d74;
  }
}
</style>
